(function () {
  'use strict';

  function initialiseTradePage(root) {
    if (!root || root.dataset.tradeInitialised === 'true') return;
    root.dataset.tradeInitialised = 'true';

    var form = root.querySelector('#TradeApplicationForm');
    if (!form) return;

    var products = Array.prototype.slice.call(form.querySelectorAll('[data-trade-products] input[type="checkbox"]'));
    var error = form.querySelector('[data-trade-products-error]');

    function validateProducts() {
      var hasSelection = products.some(function (input) { return input.checked; });
      if (error) error.hidden = hasSelection;
      products.forEach(function (input) {
        input.setAttribute('aria-invalid', hasSelection ? 'false' : 'true');
        if (error) input.setAttribute('aria-describedby', 'TradeProductsError');
      });
      return hasSelection;
    }

    if (error) error.id = 'TradeProductsError';

    products.forEach(function (input) {
      input.addEventListener('change', validateProducts);
    });

    form.addEventListener('submit', function (event) {
      if (validateProducts()) return;
      event.preventDefault();
      if (products[0]) products[0].focus();
    });
  }

  function initialiseAllTradePages(scope) {
    Array.prototype.slice.call((scope || document).querySelectorAll('[data-trade-page]')).forEach(initialiseTradePage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialiseAllTradePages(document); });
  } else {
    initialiseAllTradePages(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAllTradePages(event.target);
  });
})();
